module.exports = __webpack_public_path__ + "static/media/mainMenu.4b495c0f.jpg";